<template>
  <div
      class="room-group-area-wrapper"
      draggable="false"
      :ref="'videos_group_layer' + roomGroup.roomGroupId"
      :data-group-id="roomGroup.roomGroupId"
      :style="roomCallGroupStyle"
  >
    <div class="room-group-area"
         :style="{
           height: `${roomGroup.videoRectList.height}px`,
         }"
    >
      <RoomGroupVideoFilmContainer :roomGroup="roomGroup" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import RoomGroupVideoFilmContainer from "./RoomGroupVideoFilmContainer.vue"

export default {
  name: "RoomCallGroup",
  components: {
    RoomGroupVideoFilmContainer,
  },
  props: [
    'roomGroup'
  ],
  computed: {
    ...mapGetters('roomGroup', [
      'isInRoomGroup',
      'getRoomGroupName',
      'getRoomGroup',
    ]),

    roomCallGroupStyle() {
      return {
        width: `${this.roomGroup.width}px`,
        height: `${this.roomGroup.height}px`,
        left: `${this.roomGroup.left}px`,
        top: this.isInRoomGroup() && !this.getRoomGroup(this.roomGroup.roomGroupId).mode ? '' : `${this.roomGroup.top}px`
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.room-group-area-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  user-select: none;
}
.room-group-area {
  width: 100%;
}
</style>